import { Loc } from 'main.core';
import { EventEmitter } from 'main.core.events';
import { EventType } from 'im.const';
import { Cookie } from 'im.lib.cookie';
import './index.css';

/**
 * Class OpenLines - Модификация стандартного функционала открытых линий
 *
 * @see eventListener() - Регистрация слушателей событий
 * @see #onLoadPage(url: String) - Инициализация формы
 * @see #onBitrixLiveChat(arParams: Object) - Инициализация кастомного функционала формы
 * @see #getCustomData(arParams: Object) - Собираем массив в правильной* последовательности
 * @see #onMutateComponent() - Мутируем глобальный компонент для визуального скрытия
 * @see #onSubmissionForm() - Подписка на событие открытия модального окна
 * @see #onOperatorMessage() - Подписка на отложенную отправку
 * @see #sendForm(parentNode: String) - Отправка формы
 * @see #onMessageBody(): void - Мутируем компонент сообщений для вставки кнопок
 *
 * @namespace {BX.Evraz.Crm}
 */
export class OpenLines
{
    arParams;
    oWidget;
    arCustomData;
    isSendRequest;
    isAllFieldsRequired;
    iCountMaxInterval;

    divMessageId = `.bx-im-dialog-list-item-reference-#MESSAGE_ID#`;
    inputName = `input[name="name"]`;
    inputEmail = `input[name="email"]`;
    inputPhone = `input[name="phone"]`;
    divForm = `.bx-imopenlines-form-content`;
    btnForm = `.b24-form-btn`;
    sChatColor = `#000000`;
    sSystemColor = `#707070`;
    sCommandAuth = '/get_auth';

    constructor(arParams = {}): void
    {
        this.arParams = arParams;
        window.openlineschat = this;
    }

    eventListener(): void
    {
        let self = this;
        if (!Object.keys(self.arParams).length) {
            return;
        }
        if (!self.arParams.UTILS.ARM_CRM_URL.length) {
            return;
        }
        this.#onLoadPage(self.arParams.UTILS.ARM_CRM_URL);
        this.#onBitrixLiveChat(self.arParams);
    }

    onSelectBitrixOpenLinesBtn(event): void
    {
        let text = event.innerHTML;
        let command = event.dataset.event;
        let iMessage = 0;
        let isNeedSendMessage = true;
        let nodeMessageItemId = event.closest(`.bx-im-dialog-list-item.bx-im-dialog-list-item-reference`).dataset.messageId;
        let nodeMessageItem = event.closest(`.bx-im-dialog-list-item.bx-im-dialog-list-item-reference.bx-im-dialog-list-item-reference-${nodeMessageItemId}`);
        let nodeDialogList = event.closest(`.bx-im-dialog-list`);
        let arNodeDialogMessages = nodeDialogList.querySelectorAll(`.bx-im-dialog-list-item.bx-im-dialog-list-item-reference`);
        let isUserCompleteAuth = BX.getCookie('LIVECHAT_FAST_ORDER_ON_AUTH');

        if (typeof isUserCompleteAuth === 'undefined') {
            isUserCompleteAuth = false;
        } else {
            if (!isUserCompleteAuth || isUserCompleteAuth === '0') {
                isUserCompleteAuth = false;
            } else {
                isUserCompleteAuth = true;
            }
        }

        arNodeDialogMessages.forEach((element, index) => {
            if (element.dataset.messageId === nodeMessageItemId) {
                iMessage = index+1;
            }
        });

        arNodeDialogMessages.forEach((element, index) => {
            if (index >= iMessage) {
                if (element.querySelector(`.bx24-arm-open-lines_btn`)) {
                    isNeedSendMessage = false;
                }
            }
        });

        if (!isNeedSendMessage && !isUserCompleteAuth) {
            return;
        }

        arNodeDialogMessages.forEach((element, index) => {
            if (index >= iMessage) {
                if (element.querySelector(`.bx-im-message-content-text`)) {
                    if (element.querySelector(`.bx-im-message-content-text`).innerHTML.includes(command)) {
                        isNeedSendMessage = false;
                    }
                }
            }
        });

        if (!isNeedSendMessage && !isUserCompleteAuth) {
            return;
        }

        if (typeof this.arParams['USER'] === 'undefined') {
            this.arParams = BX.localStorage.get('bx-livechat-user');
        }

        if (this.arParams['USER']['entityID'].length && command.includes('fast_order')) {
            command += JSON.stringify(this.arParams['USER']);

            BX.setCookie('LIVECHAT_FAST_ORDER_ON_AUTH', 0, {
                expires: 365 * 86400,
                path: '/',
                domain: `.${this.arParams['UTILS']['BASE_URL']}`
            });
        } else if (!this.arParams['USER']['entityID'].length && command.includes('fast_order')) {
            command = this.sCommandAuth;

            BX.setCookie('LIVECHAT_FAST_ORDER_ON_AUTH', 1, {
                expires: 365 * 86400,
                path: '/',
                domain: `.${this.arParams['UTILS']['BASE_URL']}`
            });
        }

        document.querySelector('.bx-im-textarea-input').focus();
        document.querySelector('.bx-im-textarea-input').value = `<span data-rasa-event="${command}">${text}</span>`;
        document.querySelector('.bx-im-textarea-input').dispatchEvent(new Event('input'));
    }

    #onLoadPage(url: String): void
    {
        window.addEventListener('load', function () {
            (function (w, d, u) {
                var s = d.createElement('script');
                s.async = true;
                s.src = u + '?' + (Date.now() / 60000 | 0);
                var h = d.getElementsByTagName('script')[0];
                h.parentNode.insertBefore(s, h);
            })(window, document, `${url}upload/crm/site_button/loader_1_i117pp.js`);
        });
    }

    #onBitrixLiveChat(arParams: Object): void
    {
        let self = this;
        window.addEventListener('onBitrixLiveChat', function(event) {
            self.oWidget = event.detail.widget;
            self.arCustomData = [];
            self.isSendRequest = false;
            self.isAllFieldsRequired = true;
            self.iCountMaxInterval = 0;

            if (!arParams['USER']['phone'].length || !arParams['USER']['name'].length) {
                self.isAllFieldsRequired = false;
            } else {
                self.#onMutateComponent();
            }

            self.arCustomData = self.#getCustomData(arParams);

            self.oWidget.setCustomData(self.arCustomData);

            self.#onWidgetOpen();

            self.#onOperatorMessage();

            self.#onMessageBody();

            self.#onTextAreaInPut();

            self.#onSessionStart();

            self.#checkFastOrderFromAuth();

        });
    }

    #checkFastOrderFromAuth(): void {
        let self = this;
        let isUserCompleteAuth = BX.getCookie('LIVECHAT_FAST_ORDER_ON_AUTH');

        if (typeof isUserCompleteAuth === 'undefined') {
            return;
        }

        if (!isUserCompleteAuth || isUserCompleteAuth === '0') {
            return;
        }

        self.oWidget.open();
    }

    #getCustomData(arParams: Object): Array
    {
        let arCustomData = [];

        if (arParams['USER']['entityID'].length) {
            arCustomData.push({
                "USER":
                    {
                        "NAME": arParams['USER']['name'],
                    }
            });
        }

        arCustomData.push({
                "LINK":
                    {
                        NAME: window.document.title || window.location.href,
                        LINK: window.location.href,
                    }
            },
            {
                "DELIMITER":
                    {
                        COLOR: this.sSystemColor
                    }

            });

        arCustomData.push({
            "GRID": [
                {
                    "NAME": Loc.getMessage('EVRAZ_CRM_OPEN_LINES_REGION'),
                    "VALUE": arParams['UTILS']['CITY'],
                    "COLOR": this.sChatColor,
                    "DISPLAY": "LINE",
                    "WIDTH": 200
                },
                {
                    "NAME": Loc.getMessage('EVRAZ_CRM_OPEN_LINES_REGION_CODE'),
                    "VALUE": arParams['UTILS']['REGION_CODE'],
                    "DISPLAY": "LINE"
                },
            ]
        });

        if (arParams['USER']['entityID'].length) {
            arCustomData.push({
                "GRID": [
                    {
                        "NAME": Loc.getMessage('EVRAZ_CRM_OPEN_LINES_PHONE'),
                        "VALUE": arParams['USER']['phone'],
                        "COLOR": this.sChatColor,
                        "DISPLAY": "BLOCK"
                    },
                    {
                        "NAME": Loc.getMessage('EVRAZ_CRM_OPEN_LINES_EMAIL'),
                        "VALUE": arParams['USER']['email'],
                        "COLOR": this.sChatColor,
                        "DISPLAY": "BLOCK"
                    },
                    {
                        "NAME": Loc.getMessage('EVRAZ_CRM_OPEN_LINES_1C'),
                        "VALUE": arParams['USER']['entityID'],
                        "COLOR": this.sSystemColor,
                        "DISPLAY": "BLOCK"
                    },
                ]
            });
        }

        BX.localStorage.set('bx-livechat-custom-data', arCustomData, 31104000);
        BX.localStorage.set('bx-livechat-user', arParams, 31104000);

        return arCustomData;
    }

    #onMutateComponent(): void
    {
        let self = this;
        if (typeof self.oWidget === 'undefined') {
            return;
        }

        self.oWidget.mutateTemplateComponent('bx-imopenlines-form', {
            template: `
                   <div class="evraz-b24-form-mutable-template">
                        #PARENT_TEMPLATE#
                    </div>
                `
        });
    }

    #onWidgetOpen(): void
    {
        let self = this;
        let isUserCompleteAuth = BX.getCookie('LIVECHAT_FAST_ORDER_ON_AUTH');

        if (typeof self.oWidget === 'undefined') {
            return;
        }

        if (!self.arParams.UTILS.BASE_URL.length) {
            return;
        }

        if (self.arParams.UTILS.ARM_CRM_URL.length && typeof BX.getCookie('LIVECHAT_WEBHOOK_ON_CHANGE_REGION') == 'undefined') {
            BX.setCookie('LIVECHAT_WEBHOOK_ON_CHANGE_REGION', self.arParams.UTILS.WEBHOOK_ON_CHANGE_REGION, {
                expires: 365 * 86400,
                path: '/',
                domain: `.${self.arParams.UTILS.BASE_URL}`
            });
        }

        self.oWidget.subscribe({
            type: BX.LiveChatWidget.SubscriptionType.widgetOpen,
            callback: function (data) {
                BX.setCookie('LIVECHAT_CURRENT_REGION', self.arParams.UTILS.REGION_CODE, {
                    expires: 365*86400,
                    path: '/',
                    domain: `.${self.arParams.UTILS.BASE_URL}`
                });

                // Если пользователь авторизовывался до перезагрузки страницы, авторизовался и страница перезагрузилась
                if (typeof isUserCompleteAuth !== 'undefined' && (isUserCompleteAuth === 1 || isUserCompleteAuth === '1')) {
                    setTimeout(function () {
                        let arMessages = document.querySelectorAll('.bx24-arm-open-lines_btn');
                        arMessages.forEach(function (item, index) {
                            if (item.dataset.event === '/fast_order') {
                                item.click();
                            }
                        });
                    }, 750);
                }
            }
        });

        BX.localStorage.set('bx-livechat-base-url', self.arParams.UTILS.BASE_URL, 31104000);
    }

    #onOperatorMessage(): void
    {
        let self = this;

        if (typeof self.oWidget === 'undefined') {
            return;
        }

        self.oWidget.subscribe({
            type: BX.LiveChatWidget.SubscriptionType.operatorMessage,
            callback: function (data) {
                if (data.message.params.IS_WELCOME_FORM !== 'Y') {
                    return;
                }
                if (!self.arParams['USER']['entityID'].length) {
                    return;
                }
                if (!self.isAllFieldsRequired) {
                    return;
                }
                self.divMessageId = self.divMessageId.replace(`#MESSAGE_ID#`, data.message.id);
                self.#sendForm(self.divMessageId);
            }
        });
    }

    #onTextAreaInPut(): void
    {
        let self = this;

        if (typeof self.oWidget === 'undefined') {
            return;
        }

        self.oWidget.mutateTemplateComponent('bx-im-component-textarea', {
            data()
            {
                return {
                    ...this.parentData(),
                }
            },
            methods:
                {
                    onInput(event)
                    {
                        this.textChangeEvent();
                        if (this.currentMessage.includes('data-rasa-event')) {
                            this.sendMessage();
                        }
                    },
                    sendMessage(event)
                    {
                        let self = this;
                        let urlWebHookChangeRegion = BX.getCookie('LIVECHAT_WEBHOOK_ON_CHANGE_REGION');
                        let currentRegionCode = BX.getCookie('LIVECHAT_CURRENT_REGION');
                        let sessionRegionCode = BX.getCookie('LIVECHAT_SESSION_REGION');

                        if (
                            typeof urlWebHookChangeRegion !== "undefined"
                            && typeof currentRegionCode !== "undefined"
                            && typeof sessionRegionCode !== "undefined"
                        ) {
                            if (currentRegionCode !== sessionRegionCode) {
                                BX.ajax({
                                    url: urlWebHookChangeRegion,
                                    method: 'POST',
                                    dataType: 'json',
                                    data: {
                                        dialogId: self.$Bitrix.Data.get('controller').store.state.widget.dialog.operatorChatId,
                                        userHash: BX.getCookie('LIVECHAT_HASH'),
                                        oRegion: BX.localStorage.get('bx-livechat-custom-data'),
                                        code: currentRegionCode,
                                    },
                                    skipAuthCheck: true,
                                    skipBxHeader: true,
                                    // timeout: 1,
                                    onsuccess: function(data) {
                                        self.onSendMessageToCrm();
                                        BX.setCookie('LIVECHAT_SESSION_REGION', currentRegionCode, {
                                            expires: 365 * 86400,
                                            path: '/',
                                            domain: `.${BX.localStorage.get('bx-livechat-base-url')}`
                                        });
                                    },
                                    onfailure: function() {
                                        self.onSendMessageToCrm();
                                        BX.setCookie('LIVECHAT_SESSION_REGION', currentRegionCode, {
                                            expires: 365 * 86400,
                                            path: '/',
                                            domain: `.${BX.localStorage.get('bx-livechat-base-url')}`
                                        });
                                    }
                                });
                            } else {
                                self.onSendMessageToCrm();
                            }
                        } else {
                            self.onSendMessageToCrm();
                        }
                    },
                    onSendMessageToCrm()
                    {
                        EventEmitter.emit(EventType.textarea.sendMessage, {text: this.currentMessage.trim()});
                        let textarea = this.$refs.textarea;
                        if (textarea) {
                            textarea.value = '';
                        }
                        if (this.autoFocus === null || this.autoFocus) {
                            textarea.focus();
                        }
                        this.textChangeEvent();
                    },
                },
        });
    }

    #onSessionStart(): void
    {
        let self = this;

        if (typeof self.oWidget === 'undefined') {
            return;
        }

        self.oWidget.subscribe({
            type: BX.LiveChatWidget.SubscriptionType.sessionStart,
            callback: function (data) {

                if (!self.arParams.UTILS.BASE_URL.length) {
                    return;
                }

                let hash = BX.getCookie('LIVECHAT_HASH');
                if (typeof hash === 'string' && hash.match(/^[a-f0-9]{32}$/)) {
                    BX.setCookie('LIVECHAT_HASH', hash, {
                        expires: 365*86400,
                        path: '/',
                        domain: `.${self.arParams.UTILS.BASE_URL}`
                    });
                }

                BX.setCookie('LIVECHAT_SESSION_REGION', self.arParams.UTILS.REGION_CODE, {
                    expires: 365 * 86400,
                    path: '/',
                    domain: `.${self.arParams.UTILS.BASE_URL}`
                });

                if (!self.arParams['USER']['entityID'].length) {
                    return;
                }

                if (!self.arParams.UTILS.WEBHOOK_ON_AUTH_USER) {
                    return;
                }

                BX.ajax({
                    url: self.arParams.UTILS.WEBHOOK_ON_AUTH_USER,
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        hash: BX.getCookie('LIVECHAT_HASH'),
                        user: self.arParams.USER,
                    },
                    skipAuthCheck: true,
                    skipBxHeader: true,
                    // timeout: 1,
                    onsuccess: function(data) {
                        console.log(data);
                    },
                    onfailure: function() {
                        console.log('ошибка отправки запроса');
                    }
                });

            }
        });
    }

    #onMessageBody(): void
    {
        let self = this;

        if (typeof self.oWidget === 'undefined') {
            return;
        }

        self.oWidget.mutateTemplateComponent('bx-im-view-message-body', {
            computed: {
                messageText()
                {
                    if (this.isDeleted)
                    {
                        return this.$Bitrix.Loc.getMessage('IM_MESSENGER_MESSAGE_DELETED');
                    }

                    let message = this.message.text;
                    let messageParams = this.message.params;

                    let replacement = [];
                    message = message.replace(/<!--IM_COMMAND_START-->([\0-\uFFFF]+?)<!--IM_COMMAND_END-->/ig, function(whole, text) {
                        let id = replacement.length;
                        replacement.push(text);
                        return '####REPLACEMENT_'+id+'####';
                    });

                    message = message.replace(/\[USER=([0-9]{1,})\](.*?)\[\/USER\]/ig, (whole, userId, userName) => {
                        if (!userName)
                        {
                            const user = this.$store.getters['users/get'](userId);
                            userName = user? Utils.text.htmlspecialchars(user.name): 'User '+userId;
                        }
                        return '<span class="bx-im-mention" data-type="USER" data-value="'+userId+'">'+userName+'</span>'
                    });

                    replacement.forEach((value, index) => {
                        message = message.replace('####REPLACEMENT_'+index+'####', value);
                    });

                    if (
                        typeof messageParams.LINK_ACTIVE !== 'undefined'
                        && messageParams.LINK_ACTIVE.length > 0
                        && !messageParams.LINK_ACTIVE.includes(this.userId)
                    )
                    {
                        message = message.replace(/<a.*?href="([^"]*)".*?>(.*?)<\/a>/ig, '$2');
                    }

                    // Создаем цели я.метрики
                    if (window.yaMetricNumber) {
                        //Кнопка "Перейти в корзину"
                        let currentBasketLink = 'https://' + window.baseDomain + "/api/chatbot/basket";
                        if (message.includes(currentBasketLink)) {
                            message = message.replace("location.href = '" + currentBasketLink, "gaPush.clickToBasketInOpenlines();location.href = '" + currentBasketLink);
                        }
                        //Цель для авторизации
                        if (message.includes("$('#modal6').modal('show');")) {
                            message = message.replace("$('#modal6').modal('show');", "window.openlineschat.openAuthPopup();");

                        }
                        //Кнопка "Заказать"
                        // Используем регулярное выражение для поиска тега span с атрибутом data-event="/fast_order"
                        let regex = /<span[\\n\s]*class="bx24-arm-open-lines_btn"[\\n\s]*data-event="\/fast_order"[\\n\s]*onclick="[^>]+>([^<]+)<\/span>/;
                        let match = message.match(regex);

                        // Если тег span найден, добавляем новый метод перед существующим методом
                        if (match) {
                            let newMethodStr = 'gaPush.clickMakeOrderInOpenlines();';
                            let newMessageStr = match[0].replace(
                                '(new BX.Evraz.Crm.OpenLines({})).onSelectBitrixOpenLinesBtn(this)',
                                `${newMethodStr}(new BX.Evraz.Crm.OpenLines({})).onSelectBitrixOpenLinesBtn(this)`);
                            message = message.replace(match[0], newMessageStr);
                        }
                    }

                    return message;
                },
            },
        });
    }

    // Добавляем цели яндекс метрики на открытие попапа авторизации и успешной авторизации/регистрации
    openAuthPopup() {
        BX.onCustomEventIeCompatible("addSuccessAuthCallbackList", [gaPush.succesAuthInOpenLines]);
        BX.onCustomEventIeCompatible("addSuccessRegisterCallbackList", [gaPush.succesAuthInOpenLines]);
        $('#modal6').modal('show');
        gaPush.openAuthInOpenLines();
    }

    #sendForm(parentNode: String): void
    {
        let self = this;
        self.isSendRequest = false;
        let intervalId = setInterval(function() {
            let rootNode = document.querySelector(parentNode);
            if (rootNode) {
                if (rootNode.querySelector(self.inputName)) {
                    rootNode.querySelector(self.inputName).value = self.arParams['USER']['name'];
                    rootNode.querySelector(self.inputName).dispatchEvent(new Event('input'));
                }
                if (rootNode.querySelector(self.inputEmail)) {
                    rootNode.querySelector(self.inputEmail).value = self.arParams['USER']['email'];
                    rootNode.querySelector(self.inputEmail).dispatchEvent(new Event('input'));
                }
                if (rootNode.querySelector(self.inputPhone)) {
                    rootNode.querySelector(self.inputPhone).value = self.arParams['USER']['phone'];
                    rootNode.querySelector(self.inputPhone).dispatchEvent(new Event('input'));
                }
                if (rootNode.querySelector(self.btnForm)) {
                    if (!self.isSendRequest) {
                        rootNode.querySelector(self.btnForm).click();
                        self.isSendRequest = true;
                    }
                    if (rootNode.querySelector(self.divForm).style.display === 'none') {
                        clearInterval(intervalId);
                    }
                }
            }
            self.iCountMaxInterval++;
            if (self.iCountMaxInterval > 180) {
                clearInterval(intervalId);
            }
        }, 700);
    }

}
